module.exports = __webpack_public_path__ + "static/media/RUBI_User Guide.83911aa2.jpg";